import React, { Fragment } from "react";
import Chart from "react-apexcharts";
import moment from "moment";
import axios from "../axios";
// import Adminsidebar from "./Adminsidebar";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ClipLoader from "react-spinners/ClipLoader";
// import SideBar from "./Sidebar";
import ReportsTable from "./tables/ReportsTable";
import Report from "./Report";
import Swal from "sweetalert2";
import greyTick from "../Assets/images/patientDetail/greyTick.svg";
import greyLine from "../Assets/images/patientDetail/greyLine.svg";
import yellowTick from "../Assets/images/patientDetail/yellowTick.svg";
import yellowLine from "../Assets/images/patientDetail/yellowLine.svg";
import greenTick from "../Assets/images/patientDetail/greenTick.svg";
import greenLine from "../Assets/images/patientDetail/greenLine.svg";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { NotificationManager } from 'react-notifications';
import FormControlLabel from "@mui/material/FormControlLabel";
import { withStyles } from "@mui/styles";
import Checkbox from "@mui/material/Checkbox";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import SurgicalHistoryDialog from "./Dialogues/SurgicalHistoryDialog";
import MedicationHistoryDialog from "./Dialogues/MedicationHistoryDialog";
import ClinicalTestDialog from "./Dialogues/ClinicalTestDialog";
// import profile from "../Assets/images/profile.png";
import low_risk_img from "../Assets/images/low_risk_meter.svg";
import med_risk_img from "../Assets/images/med_risk_meter.svg";
import high_risk_img from "../Assets/images/high_risk_meter.svg";
// import Navbar from "./Navbar";
// import AdminNavbar from "./Adminsidebar";
import Topbar from "./Topbar";
import { ShimmerThumbnail } from "react-shimmer-effects";
import PatientDetailsNew from "./PatientDetailsNew";
import Typography from "@mui/material/Typography";

const medicalConditions = [
  {
    name: "Personal History",
    id: 1,
  },
  {
    name: "Medical/Surgical History",
    id: 2,
  },
  {
    name: "Medical Condition",
    id: 3,
  },
  {
    name: "Medication History",
    id: 4,
  },
  {
    name: "Clinical Test",
    id: 5,
  },
  {
    name: "Adverse Event Monitoring",
    id: 6,
  },
  {
    name: "Study Completion Details",
    id: 7,
  },
];

const GreenCheckbox = withStyles({
  root: {
    // color: "#06e241",
    "&$checked": {
      color: "#06e241",
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

class PatientDetail extends React.Component {
  constructor() {
    super();

    this.state = {
      responseData : "",
      index: 0,
      mdlength: 1,
      add: false,
      created: "",
      tb: "",
      covid: "",
      copd: "",
      asthma: "",

      loading: false,
      records: [],
      totalRecordLength: 0,
      errorRecordLength: 0,
      latestRecord: {},
      latestRecordLink: "",
      report: "",
      user: {},
      dates: [],
      wetCoughs: {},
      dryCoughs: {},

      riskScore: 0,
      covidRiskScore: 0,
      tbRiskScore: 0,
      asthmaRiskScore: 0,
      copdRiskScore: 0,

      FEV1ScoreData: [],
      FEV1ScoreStartDate: "",
      FEV1ScoreEndDate: "",
      FEV1ScoreDates: [],

      FVCScoreData: [],
      FVCScoreStartDate: "",
      FVCScoreEndDate: "",
      FVCScoreDates: [],

      FEV1FVCScoreData: [],
      FEV1FVCScoreStartDate: "",
      FEV1FVCScoreEndDate: "",
      FEV1FVCScoreDates: [],

      riskScoreData: [],
      riskScoreStartDate: "",
      riskScoreEndDate: "",
      riskScoreDates: [],

      temperatures: [],
      temperatureStartDate: "",
      temperatureEndDate: "",
      temperatureDates: [],
      dryCoughStartDate: "",
      dryCoughEndDate: "",
      dryCoughDates: [],
      wetCoughStartDate: "",
      wetCoughEndDate: "",
      wetCoughDates: [],
      userId: "",
      doctorId: "",
      patientIdSQL: "",

      adminId: "",

      asthmaRiskScoreData: [],
      asthmaRiskScoreStartDate: "",
      asthmaRiskScoreEndDate: "",
      asthmaRiskScoreDates: "",

      copdRiskScoreData: [],
      copdRiskScoreStartDate: "",
      copdRiskScoreEndDate: "",
      copdRiskScoreDates: "",

      tbRiskScoreData: [],
      tbRiskScoreStartDate: "",
      tbRiskScoreEndDate: "",
      tbRiskScoreDates: "",

      covidRiskScoreData: [],
      covidRiskScoreStartDate: "",
      covidRiskScoreEndDate: "",
      covidRiskScoreDates: "",

      tab: "medical",
      status: "",
      positionVal: 1,
      surgicalHistoryData: [],
      showSurgicalModal: false,
      medicationHistoryData: [],
      showMedicationHistoryModal: false,
      clinicalTestData: [],
      showClinicalTestModal: false,

      personalHistory: {
        alcoholAbuse: "No",
        personnelHistory: "No",
        tobaccoUsageDuration: "",
        substanceAbuse: "No",
        tobacco: false,
        drugs: false,
        alcohol: false,
        alcoholUsageDuration: "",
        narcoticsAbuse: "No",
        personnelHistoryComments: "",
        tobaccoAbuse: "No",
        narcoticsUsageDuration: "",
        active_tb_past: "No",
        known_person_having_active_tb: "No",
      },
      medicalhistory: {
        heart_disease: false,
        high_blood_pressure: false,
        kidney_problem: false,
        diabetes: false,
        lung_disease: false,
        weak_immune_system: false,
        stroke: false,
        major_operations: false,
        comments: "",
      },
      studyAndAdverse: {
        adverse_event: "No",
        adverse_event_details: "",
        study_complete: "No",
        study_complete_date: null,
        subject_discontinuity_reason: "",
        subject_death_date: null,
        cause_of_death: "",
      },
      historyOfSubstanceAbuseError: false,
      alcoholUsageDurationError: false,
      tobaccoUsageDurationError: false,
      narcoticsUsageDurationError: false,
      personnelHistoryCommentsError: false,
    };
  }
  getDoctors = () =>
    axios
      .get(`/getDoctors`, {
        headers: { accessToken: localStorage.accessToken },
      })
      .then((response) => {
        // console.log(response);
        let country = response.data.data.users.find(
          (e) => e.loginId === this.props.match.params.doctorId
        );
        try {
          if (country.plan.includes("tb")) {
            localStorage.setItem("Tb", "tb");
            this.setState({ tb: "tb" });
            // console.log(lo)
          } else {
            localStorage.setItem("Tb", "");
            this.setState({ tb: "" });
          }
          if (country.plan.includes("covid")) {
            localStorage.setItem("plan", "covid");
            this.setState({ covid: "covid" });
          } else {
            localStorage.setItem("plan", "");
            this.setState({ covid: "" });
          }

          if (country.plan.includes("copd")) {
            localStorage.setItem("plan", "copd");
            this.setState({ copd: "copd" });
            // console.log(lo)
          } else {
            localStorage.setItem("plan", "");
            this.setState({ copd: "" });
          }
          if (country.plan.includes("asthma")) {
            localStorage.setItem("plan", "asthma");
            this.setState({ asthma: "asthma" });
            // console.log(lo)
          } else {
            localStorage.setItem("plan", "");
            this.setState({ asthma: "" });
          }
        } catch (e) {
          console.log("noPlan");
          localStorage.setItem("Tb", "");
          this.setState({ tb: "" });
          localStorage.setItem("plan", "");
          this.setState({ covid: "" });
          localStorage.setItem("copd", "");
          this.setState({ copd: "" });
          localStorage.setItem("asthma", "");
          this.setState({ asthma: "" });
        }
        this.setState({ loading: true });
      });

  getPatientData = () => {
    this.setState({
      userid: decodeURIComponent(this.props.match.params.patientId),
      doctorId: this.props.match.params.doctorId,
    });

    const userid = decodeURIComponent(this.props.match.params.patientId);
    const doctorId = this.props.match.params.doctorId;

    let formdata = new FormData();
    formdata.append("patientId", userid.toString());
    formdata.append("doctorId", doctorId);

    axios({
      method: "POST",
      url: `/getPatientRecords`,
      data: formdata,
      headers: {
        accessToken: localStorage.accessToken,
      },
    })
      .then((response) => {
        // console.log("getPatientRecords ", response.data);
        this.setState({
          responseData: response,
          user: response.data.patientDetails,
          status: response.data.patientDetails.status,
          adminId: response.data.patientDetails.adminId,
          // mdlength: response.data.patientDetails.medicalRecords.length
        });
        this.setState({ patientIdSQL: response.data.patientDetails.id });
        if (localStorage.user !== "admin") {
          this.setState({ loading: true});
        }
        if (localStorage.longitudinal_study === "true") {
          try {
            this.setState({
              mdlength:  response?.data?.patientDetails?.medicalRecords.length,
              created:
              response?.data?.patientDetails?.medicalRecords[this.state.index]
                  ?.createdOn,
            });
          } catch (error) {
            console.log("longitude", error);
          }
        }

        const filteredResult =
          response.data.records.filter(checkSuccessRecords);
        const filteredResult1 = response.data.records.filter(checkErrorRecords);

        const totalRecordLength = response.data.records.length;
        const errorRecordLength = filteredResult1.length;

        function checkSuccessRecords(e) {
          console.log(e.status);
          return e.status === "SUCCESS";
        }
        function checkErrorRecords(e) {
          console.log(e.status);
          return e.status === "ERROR";
        }
        const records = filteredResult.sort((a, b) => {
          return moment(a.timestamp).diff(moment(b.timestamp));
        });

        if (localStorage.longitudinal_study === "true") {
          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.personnel_history
          ) {
            const substanceTypes =
              response.data.patientDetails.medicalRecords[this.state.index]
                .medicalRecords.personnel_history.substanceTypes || "";
            // console.log("hhdhshdh")
            // console.log(substanceTypes.includes("Alcohol"))
            const personalHistory =
              response.data.patientDetails.medicalRecords[this.state.index]
                .medicalRecords.personnel_history;

            console.log("personal history");
            console.log(personalHistory);
            this.setState({
              personalHistory: {
                alcoholAbuse: personalHistory?.alcoholAbuse || "No",
                personnelHistory: personalHistory?.personnelHistory || "No",
                tobaccoUsageDuration:
                  personalHistory?.tobaccoUsageDuration || "",
                substanceAbuse: personalHistory?.substanceAbuse || "No",
                alcohol:
                  personalHistory?.alcohol ||
                  substanceTypes.includes("Alcohol"),
                tobacco:
                  personalHistory?.tobacco ||
                  substanceTypes.includes("Tobacco"),
                drugs:
                  personalHistory?.drugs ||
                  substanceTypes.includes("Drugs (Narcotic)"),
                alcoholUsageDuration:
                  personalHistory?.alcoholUsageDuration || "",
                narcoticsAbuse: personalHistory?.narcoticsAbuse || "No",
                personnelHistoryComments:
                  personalHistory?.personnelHistoryComments || "",
                tobaccoAbuse: personalHistory?.tobaccoAbuse || "No",
                narcoticsUsageDuration:
                  personalHistory?.narcoticsUsageDuration || "",
                active_tb_past: personalHistory?.active_tb_past || "No",
                known_person_having_active_tb:
                  personalHistory?.known_person_having_active_tb || "No",
              },
            });

            console.log(personalHistory);
          }

          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.surgicalHistory
          ) {
            let surgicalHistory =
              JSON.parse(
                response.data.patientDetails.medicalRecords[this.state.index]
                  .medicalRecords.surgicalHistory
              ) || [];
            const surgicalHistoryData = surgicalHistory.map((item) => {
              const data = {
                Diagnosis: item.Diagnosis,
                endDate: item.endDate,
                startDate: item.startDate,
                ongoing: item.ongoing,
              };
              return data;
            });
            console.log("surgical history");
            console.log(surgicalHistoryData);
            this.setState({ surgicalHistoryData });
          }

          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.medicalhistory
          ) {
            let medicalhistory =
              response.data.patientDetails.medicalRecords[this.state.index]
                .medicalRecords.medicalhistory;
            console.log(medicalhistory);
            this.setState({
              medicalhistory: {
                heart_disease: !!medicalhistory["heart_disease"],
                high_blood_pressure: !!medicalhistory["high_blood_pressure"],
                kidney_problem: !!medicalhistory["kidney_problem"],
                diabetes: !!medicalhistory["diabetes"],
                lung_disease: !!medicalhistory["lung_disease"],
                weak_immune_system: !!medicalhistory["weak_immune_system"],
                stroke: !!medicalhistory["stroke"],
                major_operations: !!medicalhistory["major_operations"],
                comments: medicalhistory["comments"] || "",
              },
            });
          }

          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.medicationHistory
          ) {
            let medicationHistory =
              JSON.parse(
                response.data.patientDetails.medicalRecords[this.state.index]
                  .medicalRecords.medicationHistory
              ) || []; 
            console.log(medicationHistory);
            const medicationHistoryData = medicationHistory.map((item) => {
              const data = {
                drugName: item.drugName,
                endDate: item.endDate,
                startDate: item.startDate,
                dose: item.dose,
                response: item.response,
              };
              return data;
            });
            console.log(medicationHistoryData);
            this.setState({ medicationHistoryData });
          }

          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.clinicalTest
          ) {
            let clinicalTest = JSON.parse(
              response.data.patientDetails.medicalRecords[this.state.index]
                .medicalRecords.clinicalTest
            );
            console.log(clinicalTest);
            
            const clinicalTestData = clinicalTest.map((item) => {
              const parameters = item.parameters.map((param) => {
                return {
                  test_parameter_name: param.test_parameter_name,
                  test_parameter_value: param.test_parameter_value,
                };
              });
              const data = {
                test_id: item.test_id,
                test_name: item.test_name,
                test_count: item.test_count,
                comments: item.comments,
                reportID: item.reportID,
                parameters,
              };
              return data;
            });
            console.log(clinicalTestData);
            this.setState({ clinicalTestData });
          }

          if (
            response?.data?.patientDetails?.medicalRecords[this.state.index]
              ?.medicalRecords?.study_data
          ) {
            let studyAndAdverse =
              response.data.patientDetails.medicalRecords[this.state.index]
                .medicalRecords.study_data;

            let study = studyAndAdverse["study_complete_date"];
            console.log(studyAndAdverse["study_complete_date"]);
            if (study) {
              if (study.includes("T")) {
              } else {
                study = study.replace(":", "-");
              }
            }
            let death = studyAndAdverse["subject_death_date"];
            if (death) {
              if (death.includes("T")) {
              } else {
                death = death.replace(":", "-");
              }
            }

            console.log(studyAndAdverse);
            this.setState({
              studyAndAdverse: {
                studyCompletion: studyAndAdverse["studyCompletion"],
                adverse_event: studyAndAdverse["adverse_event"],
                adverse_event_details: studyAndAdverse["adverse_event_details"],

                subject_discontinuity_reason:
                  studyAndAdverse["subject_discontinuity_reason"],
                cause_of_death: studyAndAdverse["cause_of_death"],

                study_complete: studyAndAdverse["study_complete"],
                subject_death_date: studyAndAdverse["subject_death_date"]
                  ? moment(death).toDate()
                  : null,
                study_complete_date: studyAndAdverse["study_complete_date"]
                  ? moment(study).toDate()
                  : null,
              },
            });
          }
        } else {
          if (response?.data?.patientDetails?.personnel_history) {
            const substanceTypes =
              response.data.patientDetails.personnel_history.substanceTypes ||
              "";
            // console.log("sushsjjsj")
            // console.log(substanceTypes)
            const personalHistory =
              response.data.patientDetails.personnel_history;
            console.log(personalHistory);
            this.setState({
              personalHistory: {
                alcoholAbuse: personalHistory?.alcoholAbuse || "No",
                personnelHistory: personalHistory?.personnelHistory || "No",
                tobaccoUsageDuration:
                  personalHistory?.tobaccoUsageDuration || "",
                substanceAbuse: personalHistory?.substanceAbuse || "No",
                alcohol:
                  personalHistory?.alcohol ||
                  substanceTypes.includes("Alcohol"),
                tobacco:
                  personalHistory?.tobacco ||
                  substanceTypes.includes("Tobacco"),
                drugs:
                  personalHistory?.drugs ||
                  substanceTypes.includes(" Drugs (Narcotic)"),
                alcoholUsageDuration:
                  personalHistory?.alcoholUsageDuration || "",
                narcoticsAbuse: personalHistory?.narcoticsAbuse || "No",
                personnelHistoryComments:
                  personalHistory?.personnelHistoryComments || "",
                tobaccoAbuse: personalHistory?.tobaccoAbuse || "No",
                narcoticsUsageDuration:
                  personalHistory?.narcoticsUsageDuration || "",
                active_tb_past: personalHistory?.active_tb_past || "No",
                known_person_having_active_tb:
                  personalHistory?.known_person_having_active_tb || "No",
              },
            });
            // console.log(personalHistory);
          }

          if (response?.data?.patientDetails?.surgicalHistory) {
            let surgicalHistory =
              JSON.parse(response.data.patientDetails.surgicalHistory) || [];
            const surgicalHistoryData = surgicalHistory.map((item) => {
              const data = {
                Diagnosis: item.Diagnosis,
                endDate: item.endDate,
                startDate: item.startDate,
                ongoing: item.ongoing,
              };
              return data;
            });
            // console.log("surgical history");
            // console.log(surgicalHistoryData);
            this.setState({ surgicalHistoryData });
          }

          if (response?.data?.patientDetails?.medicalHistory) {
            let medicalhistory = response.data.patientDetails.medicalHistory;
            // console.log(medicalhistory);
            this.setState({
              medicalhistory: {
                heart_disease: !!medicalhistory["heart_disease"],
                high_blood_pressure: !!medicalhistory["high_blood_pressure"],
                kidney_problem: !!medicalhistory["kidney_problem"],
                diabetes: !!medicalhistory["diabetes"],
                lung_disease: !!medicalhistory["lung_disease"],
                weak_immune_system: !!medicalhistory["weak_immune_system"],
                stroke: !!medicalhistory["stroke"],
                major_operations: !!medicalhistory["major_operations"],
                comments: medicalhistory["comments"] || "",
              },
            });
          }

          if (response?.data?.patientDetails?.medicationHistory) {
            let medicationHistory =
              JSON.parse(response.data.patientDetails.medicationHistory) || [];
            console.log(medicationHistory);
            const medicationHistoryData = medicationHistory.map((item) => {
              const data = {
                drugName: item.drugName,
                endDate: item.endDate,
                startDate: item.startDate,
                dose: item.dose,
                response: item.response,
              };
              return data;
            });
            // console.log(medicationHistoryData);
            this.setState({ medicationHistoryData });
          }

          if (response?.data?.patientDetails?.clinicalTest) {
            let clinicalTest = JSON.parse(
              response.data.patientDetails.clinicalTest
            );
            console.log(clinicalTest);
            const clinicalTestData = clinicalTest.map((item) => {
              const parameters = item.parameters.map((param) => {
                return {
                  test_parameter_name: param.test_parameter_name,
                  test_parameter_value: param.test_parameter_value,
                };
              });
              const data = {
                test_id: item.test_id,
                test_name: item.test_name,
                test_count: item.test_count,
                comments: item.comments,
                reportID: item.reportID,
                parameters,
              };
              return data;
            });
            console.log(clinicalTestData);
            this.setState({ clinicalTestData });
          }

          if (response?.data?.patientDetails?.study_data) {
            let studyAndAdverse = response.data.patientDetails.study_data;
            console.log(studyAndAdverse);
            // console.log(moment(
            //   studyAndAdverse["study_complete_date"],
            //   "YYYY:MM:DD"

            // ).toDate())
            let study = studyAndAdverse["study_complete_date"];
            console.log(studyAndAdverse["study_complete_date"]);
            if (study) {
              if (study.includes("T")) {
              } else {
                study = study.replace(":", "-");
              }
            }
            let death = studyAndAdverse["subject_death_date"];
            if (death) {
              if (death.includes("T")) {
              } else {
                death = death.replace(":", "-");
              }
            }

            this.setState({
              studyAndAdverse: {
                studyCompletion: studyAndAdverse["studyCompletion"],
                adverse_event: studyAndAdverse["adverse_event"],
                study_complete: studyAndAdverse["study_complete"],
                adverse_event_details: studyAndAdverse["adverse_event_details"],
                subject_discontinuity_reason:
                  studyAndAdverse["subject_discontinuity_reason"],
                cause_of_death: studyAndAdverse["cause_of_death"],

                subject_death_date: studyAndAdverse["subject_death_date"]
                  ? moment(death).toDate()
                  : null,
                study_complete_date: studyAndAdverse["study_complete_date"]
                  ? moment(study).toDate()
                  : null,
              },
            });
          }
        }
        this.setState(
          {
            records,
            totalRecordLength,
            errorRecordLength,
            latestRecord: records[records.length - 1],
            userId: response.data.patientDetails.patientId,
            riskScore: records[records.length - 1].cough_risk_score
              ? records[records.length - 1].cough_risk_score
              : 0,
            covidRiskScore: records[records.length - 1].covid_risk_score
              ? records[records.length - 1].covid_risk_score
              : 0,
            tbRiskScore: records[records.length - 1].tb_RiskScore
              ? records[records.length - 1].tb_RiskScore
              : 0,

            copdRiskScore: records[records.length - 1].COPD_risk_score
              ? records[records.length - 1].COPD_risk_score
              : 0,
            asthmaRiskScore: records[records.length - 1].asthma_risk_score
              ? records[records.length - 1].asthma_risk_score
              : 0,

            // FEV1Score: records[records.length - 1].fev1_3_value
            //   ? records[records.length - 1].fev1_3_value
            //   : 0,

            riskScoreStartDate: Date.parse(records[0].timestamp),
            riskScoreEndDate: Date.parse(records[records.length - 1].timestamp),
            temperatureStartDate: Date.parse(records[0].timestamp),
            temperatureEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            covidRiskScoreStartDate: Date.parse(records[0].timestamp),
            covidRiskScoreEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            tbRiskScoreStartDate: Date.parse(records[0].timestamp),
            tbRiskScoreEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            FEV1ScoreStartDate: Date.parse(records[0].timestamp),
            FEV1ScoreEndDate: Date.parse(records[records.length - 1].timestamp),

            FVCScoreStartDate: Date.parse(records[0].timestamp),
            FVCScoreEndDate: Date.parse(records[records.length - 1].timestamp),

            FEV1FVCScoreStartDate: Date.parse(records[0].timestamp),
            FEV1FVCScoreEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            asthmaRiskScoreStartDate: Date.parse(records[0].timestamp),
            asthmaRiskScoreEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            copdRiskScoreStartDate: Date.parse(records[0].timestamp),
            copdRiskScoreEndDate: Date.parse(
              records[records.length - 1].timestamp
            ),

            dryCoughStartDate: Date.parse(records[0].timestamp),
            dryCoughEndDate: Date.parse(records[records.length - 1].timestamp),
            wetCoughStartDate: Date.parse(records[0].timestamp),
            wetCoughEndDate: Date.parse(records[records.length - 1].timestamp),
          },
          // () => {
          //   let audioFormData = new FormData();
          //   audioFormData.append("doctorId", this.state.latestRecord.userId);
          //   audioFormData.append("recordId", this.state.latestRecord.recordId);
          //   audioFormData.append(
          //     "patientId",
          //     this.state.latestRecord.patientId
          //   );

          //   axios({
          //     method: "POST",
          //     url: "/getCoughAudioRecord",
          //     data: audioFormData,
          //     headers: { accessToken: localStorage.accessToken },
          //   })
          //     .then((response) => {
          //       this.setState({
          //         latestRecordLink: response.data.recordLink,
          //       });
          //       console.log(this.state.latestRecordLink);
          //     })
          //     .catch((error) => {
          //       console.log(error);
          //     });

          //   let formdata1 = new FormData();
          //   formdata1.append("patientId", userid.toString());
          //   formdata1.append("recordId", this.state.latestRecord.recordId);
          //   // console.log(Date.parse(records[0].timestamp), "fev1 end date");
          // }
        );

        const dates = this.extractDates(records);

        this.riskScorePlotData(records, dates);

        this.dryCoughPlotData(records, dates);

        this.wetCoughPlotData(records, dates);

        this.FEV1ScorePlotData(records, dates);

        this.FVCScorePlotData(records, dates);

        this.FEV1FVCScorePlotData(records, dates);

        this.asthmaRiskScorePlotData(records, dates);

        this.copdRiskScorePlotData(records, dates);

        this.covidRiskScorePlotData(records, dates);

        this.tbRiskScorePlotData(records, dates);
      })
      .catch((error) => {
        console.log(error)
        if(error?.response?.data?.message == 'Network Error')
          NotificationManager.error('We are sorry, something unexpected happened on our end. Please try again later.')
      
      }
       );
  };

  componentWillMount = () => {
    if (localStorage.user === "admin") {
      this.getDoctors();
    }

    // this.getPatientData();
  };
  componentDidMount = () => {
    // this.getDoctors();
    this.getPatientData();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.index !== this.state.index) {
      this.getPatientData();
      console.log("didupdate");
    }
  };

  onCloseSurgicalModal = (data) => {
    if (data !== "cancel") {
      data["startDate"] = data.startDate
        ? moment(data.startDate).format("YYYY:MM:DD")
        : "";
      data["endDate"] = data.endDate
        ? moment(data.endDate).format("YYYY:MM:DD")
        : "";
      const surgicalHistoryData = this.state.surgicalHistoryData;
      surgicalHistoryData.push(data);
      this.setState({
        surgicalHistoryData,
        showSurgicalModal: false,
      });
    } else {
      this.setState({ showSurgicalModal: false });
    }
  };

  onCloseMedicationModal = (data) => {
    if (data !== "cancel") {
      data["startDate"] = data.startDate
        ? moment(data.startDate).format("YYYY:MM:DD")
        : "";
      data["endDate"] = data.endDate
        ? moment(data.endDate).format("YYYY:MM:DD")
        : "";
      const medicationHistoryData = this.state.medicationHistoryData;
      medicationHistoryData.push(data);
      this.setState({
        medicationHistoryData,
        showMedicationHistoryModal: false,
      });
    } else {
      this.setState({ showMedicationHistoryModal: false });
    }
  };

  onCloseClinicalModal = (data) => {
    console.log(data);
    if (data !== "cancel") {
      const clinicalTestData = this.state.clinicalTestData;
      clinicalTestData.push(data);
      this.setState({ clinicalTestData, showClinicalTestModal: false });
    } else {
      this.setState({ showClinicalTestModal: false });
    }
  };

  extractDates = (records) => {
    let dates = [];

    records.map((record) => {
      dates = [...dates, moment(record.timestamp).format("DD/MM/YYYY")];
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      asthmaRiskScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    return dates;
  };

  tbRiskScorePlotData = (records, dates) => {
    let tbRiskScoreDates = {};
    console.log(dates);

    dates.map((date) => {
      tbRiskScoreDates = {
        ...tbRiskScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(tbRiskScoreDates);

    let formattedDates = [];

    Object.keys(tbRiskScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      asthmaRiskScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.tb_RiskScore !== undefined) {
          tbRiskScoreDates[date].score = [
            ...tbRiskScoreDates[date].score,
            record.tb_RiskScore ? record.tb_RiskScore : 0,
          ];
        }
      }
    });

    let tbRiskScoreData = [];
    for (const date in tbRiskScoreDates) {
      if (tbRiskScoreDates[date].score.length > 0) {
        tbRiskScoreData = [
          ...tbRiskScoreData,
          tbRiskScoreDates[date].score.reduce((a, b) => a + b) /
            tbRiskScoreDates[date].score.length,
        ];
      } else {
        tbRiskScoreData = [...tbRiskScoreData, 0];
      }
    }
    console.log(tbRiskScoreData, "tb Risk score data");
    this.setState({ tbRiskScoreData });
  };

  covidRiskScorePlotData = (records, dates) => {
    let covidRiskScoreDates = {};
    console.log(dates);

    dates.map((date) => {
      covidRiskScoreDates = {
        ...covidRiskScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(covidRiskScoreDates);

    let formattedDates = [];

    Object.keys(covidRiskScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      asthmaRiskScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.covid_risk_score !== undefined) {
          covidRiskScoreDates[date].score = [
            ...covidRiskScoreDates[date].score,
            record.covid_risk_score ? record.covid_risk_score : 0,
          ];
        }
      }
    });

    let covidRiskScoreData = [];
    for (const date in covidRiskScoreDates) {
      if (covidRiskScoreDates[date].score.length > 0) {
        covidRiskScoreData = [
          ...covidRiskScoreData,
          covidRiskScoreDates[date].score.reduce((a, b) => a + b) /
            covidRiskScoreDates[date].score.length,
        ];
      } else {
        covidRiskScoreData = [...covidRiskScoreData, 0];
      }
    }
    console.log(covidRiskScoreData, "covid Risk score data");

    this.setState({ covidRiskScoreData });
  };

  riskScorePlotData = (records, dates) => {
    let riskScoreDates = {};
    console.log(dates);

    dates.map((date) => {
      riskScoreDates = {
        ...riskScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(riskScoreDates);

    let formattedDates = [];

    Object.keys(riskScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      asthmaRiskScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.cough_risk_score !== undefined) {
          riskScoreDates[date].score = [
            ...riskScoreDates[date].score,
            record.cough_risk_score ? record.cough_risk_score : 0,
          ];
        }
      }
    });

    let riskScoreData = [];
    for (const date in riskScoreDates) {
      if (riskScoreDates[date].score.length > 0) {
        riskScoreData = [
          ...riskScoreData,
          riskScoreDates[date].score.reduce((a, b) => a + b) /
            riskScoreDates[date].score.length,
        ];
      } else {
        riskScoreData = [...riskScoreData, 0];
      }
    }
    console.log(riskScoreData, "risk score data");

    this.setState({ riskScoreData });
  };

  FEV1ScorePlotData = (records, dates) => {
    let FEV1ScoreDates = {};

    dates.map((date) => {
      FEV1ScoreDates = {
        ...FEV1ScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(FEV1ScoreDates);

    let formattedDates = [];

    Object.keys(FEV1ScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.fev1_3_value !== undefined) {
          FEV1ScoreDates[date].score = [
            ...FEV1ScoreDates[date].score,
            record.fev1_3_value ? record.fev1_3_value : 0,
          ];
        }
      }
    });

    let FEV1ScoreData = [];
    for (const date in FEV1ScoreDates) {
      if (FEV1ScoreDates[date].score.length > 0) {
        // FEV1ScoreData = [
        //   ...FEV1ScoreData,
        //   FEV1ScoreDates[date].score.reduce((a,b) => a+b) /
        //     FEV1ScoreDates[date].score.length,
        // ];
        const averageScore =
          FEV1ScoreDates[date].score.reduce((a, b) => a + parseFloat(b), 0) /
          FEV1ScoreDates[date].score.length;
        const averageScoreInteger = Math.round(averageScore); // Convert average to integer

        // Append the integer value to the FEV1ScoreData array
        FEV1ScoreData.push(
          Number.isNaN(averageScoreInteger) ? 0 : averageScoreInteger
        );
      } else {
        FEV1ScoreData = [...FEV1ScoreData, 0];
      }
    }
    console.log(FEV1ScoreData, "fev1 score data");
    this.setState({ FEV1ScoreData });
  };

  FVCScorePlotData = (records, dates) => {
    let FVCScoreDates = {};

    dates.map((date) => {
      FVCScoreDates = {
        ...FVCScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(FVCScoreDates);

    let formattedDates = [];

    Object.keys(FVCScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.fvc_3_value !== undefined) {
          FVCScoreDates[date].score = [
            ...FVCScoreDates[date].score,
            record.fvc_3_value ? record.fvc_3_value : 0,
          ];
        }
      }
    });

    let FVCScoreData = [];
    for (const date in FVCScoreDates) {
      if (FVCScoreDates[date].score.length > 0) {
        // FEV1ScoreData = [
        //   ...FEV1ScoreData,
        //   FEV1ScoreDates[date].score.reduce((a,b) => a+b) /
        //     FEV1ScoreDates[date].score.length,
        // ];
        const averageScore =
          FVCScoreDates[date].score.reduce((a, b) => a + parseFloat(b), 0) /
          FVCScoreDates[date].score.length;
        const averageScoreInteger = Math.round(averageScore); // Convert average to integer

        // Append the integer value to the FEV1ScoreData array
        FVCScoreData.push(
          Number.isNaN(averageScoreInteger) ? 0 : averageScoreInteger
        );
      } else {
        FVCScoreData = [...FVCScoreData, 0];
      }
    }
    console.log(FVCScoreData, "fev1 score data");
    this.setState({ FVCScoreData });
  };

  FEV1FVCScorePlotData = (records, dates) => {
    let FEV1FVCScoreDates = {};

    dates.map((date) => {
      FEV1FVCScoreDates = {
        ...FEV1FVCScoreDates,
        [date]: { score: [] },
      };
    });
    console.log(FEV1FVCScoreDates);

    let formattedDates = [];

    Object.keys(FEV1FVCScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.fev1fvc_2_value !== undefined) {
          FEV1FVCScoreDates[date].score = [
            ...FEV1FVCScoreDates[date].score,
            record.fev1fvc_2_value ? record.fev1fvc_2_value : 0,
          ];
        }
      }
    });

    let FEV1FVCScoreData = [];
    for (const date in FEV1FVCScoreDates) {
      if (FEV1FVCScoreDates[date].score.length > 0) {
        // FEV1ScoreData = [
        //   ...FEV1ScoreData,
        //   FEV1ScoreDates[date].score.reduce((a,b) => a+b) /
        //     FEV1ScoreDates[date].score.length,
        // ];
        const averageScore =
          FEV1FVCScoreDates[date].score.reduce((a, b) => a + parseFloat(b), 0) /
          FEV1FVCScoreDates[date].score.length;
        const averageScoreInteger = Math.round(averageScore); // Convert average to integer

        // Append the integer value to the FEV1ScoreData array
        FEV1FVCScoreData.push(
          Number.isNaN(averageScoreInteger) ? 0 : averageScoreInteger
        );
      } else {
        FEV1FVCScoreData = [...FEV1FVCScoreData, 0];
      }
    }
    console.log(FEV1FVCScoreData, "fev1 score data");
    this.setState({ FEV1FVCScoreData });
  };

  asthmaRiskScorePlotData = (records, dates) => {
    let asthmaRiskScoreDates = {};
    console.log(dates);

    dates.map((date) => {
      asthmaRiskScoreDates = {
        ...asthmaRiskScoreDates,
        [date]: { score: [] },
      };
    });
    console.log("asthma risk score dates", asthmaRiskScoreDates);

    let formattedDates = [];

    Object.keys(asthmaRiskScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      asthmaRiskScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.asthma_risk_score !== undefined) {
          asthmaRiskScoreDates[date].score = [
            ...asthmaRiskScoreDates[date].score,
            record.asthma_risk_score ? record.asthma_risk_score : 0,
          ];
        }
      }
    });

    let asthmaRiskScoreData = [];
    for (const date in asthmaRiskScoreDates) {
      if (asthmaRiskScoreDates[date].score.length > 0) {
        asthmaRiskScoreData = [
          ...asthmaRiskScoreData,
          asthmaRiskScoreDates[date].score.reduce((a, b) => a + b) /
            asthmaRiskScoreDates[date].score.length,
        ];
      } else {
        asthmaRiskScoreData = [...asthmaRiskScoreData, 0];
      }
    }
    console.log(asthmaRiskScoreData, "asthma risk score data");

    this.setState({ asthmaRiskScoreData });
  };

  copdRiskScorePlotData = (records, dates) => {
    let copdRiskScoreDates = {};
    console.log(dates);

    dates.map((date) => {
      copdRiskScoreDates = {
        ...copdRiskScoreDates,
        [date]: { score: [] },
      };
    });
    console.log("copd risk score dates", copdRiskScoreDates);

    let formattedDates = [];

    Object.keys(copdRiskScoreDates).map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({
      dates,
      dryCoughDates: formattedDates,
      wetCoughDates: formattedDates,
      riskScoreDates: formattedDates,
      temperatureDates: formattedDates,
      FEV1ScoreDates: formattedDates,
      FVCScoreDates: formattedDates,
      FEV1FVCScoreDates: formattedDates,
      copdRiskScoreDates: formattedDates,
      tbRiskScoreDates: formattedDates,
      covidRiskScoreDates: formattedDates,
    });

    records.map((record) => {
      const date = moment(record.timestamp).format("DD/MM/YYYY");

      if (dates.indexOf(date) >= 0) {
        if (record.cough_risk_score !== undefined) {
          copdRiskScoreDates[date].score = [
            ...copdRiskScoreDates[date].score,
            record.copd_risk_score ? record.copd_risk_score : 0,
          ];
        }
      }
    });

    let copdRiskScoreData = [];
    for (const date in copdRiskScoreDates) {
      if (copdRiskScoreDates[date].score.length > 0) {
        copdRiskScoreData = [
          ...copdRiskScoreData,
          copdRiskScoreDates[date].score.reduce((a, b) => a + b) /
            copdRiskScoreDates[date].score.length,
        ];
      } else {
        copdRiskScoreData = [...copdRiskScoreData, 0];
      }
    }
    console.log(copdRiskScoreData, "risk score data");

    this.setState({ copdRiskScoreData });
  };

  riskScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.riskScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.riskScoreEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ riskScoreDates: formattedDates });

    this.riskScorePlotData(this.state.records, dates);
  };
  tbRiskScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.tbRiskScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.tbRiskScoreEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ tbRiskScoreDates: formattedDates });

    this.tbRiskScorePlotData(this.state.records, dates);
  };
  covidRiskScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.covidRiskScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.covidRiskScoreEndDate).format(
      "DD/MM/YYYY"
    );

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ covidRiskScoreDates: formattedDates });

    this.covidRiskScorePlotData(this.state.records, dates);
  };

  FEV1ScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.FEV1ScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.FEV1ScoreEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ FEV1ScoreDates: formattedDates });

    this.FEV1ScorePlotData(this.state.records, dates);
  };

  FVCScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.FVCScoreStartDate).format("DD/MM/YYYY");
    const endDate = moment(this.state.FVCScoreEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ FVCScoreDates: formattedDates });

    this.FVCScorePlotData(this.state.records, dates);
  };

  FEV1FVCScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.FVCScoreStartDate).format("DD/MM/YYYY");
    const endDate = moment(this.state.FVCScoreEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ FVCScoreDates: formattedDates });

    this.FVCScorePlotData(this.state.records, dates);
  };

  asthmaRiskScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.asthmaRiskScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.asthmaRiskScoreEndDate).format(
      "DD/MM/YYYY"
    );

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ asthmaRiskScoreDates: formattedDates });

    this.asthmaRiskScorePlotData(this.state.records, dates);
  };

  copdRiskScoreDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.copdRiskScoreStartDate).format(
      "DD/MM/YYYY"
    );
    const endDate = moment(this.state.copdRiskScoreEndDate).format(
      "DD/MM/YYYY"
    );

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ copdRiskScoreDates: formattedDates });

    this.copdRiskScorePlotData(this.state.records, dates);
  };

  dryCoughPlotData(records, dates) {
    let dryCoughs = {
      morning: [],
      noon: [],
      evening: [],
      night: [],
    };

    let dryCoughData = {};

    dates.forEach((date) => {
      dryCoughData[date] = { morning: [], noon: [], evening: [], night: [] };
    });

    records.forEach((record) => {
      const istTimestamp = this.convertToIST(record.timestamp);
      const date = moment(istTimestamp).format("DD/MM/YYYY");
      const time = moment(istTimestamp).format("HH:mm:ss");

      let period = "";
      if (
        moment(time, "HH:mm:ss").isBetween(
          moment("00:00:00", "HH:mm:ss"),
          moment("12:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "morning";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("12:00:00", "HH:mm:ss"),
          moment("18:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "noon";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("18:00:00", "HH:mm:ss"),
          moment("20:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "evening";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("20:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "night";
      }

      if (dates.includes(date)) {
        dryCoughData[date][period].push(record.dry_sequence_count || 0);
      }
      console.log("date,time,period", date, time, period);
    });

    for (const date in dryCoughData) {
      dryCoughs.morning.push(
        dryCoughData[date].morning.length > 0
          ? dryCoughData[date].morning.reduce((a, b) => a + b) /
              dryCoughData[date].morning.length
          : 0
      );
      dryCoughs.noon.push(
        dryCoughData[date].noon.length > 0
          ? dryCoughData[date].noon.reduce((a, b) => a + b) /
              dryCoughData[date].noon.length
          : 0
      );
      dryCoughs.evening.push(
        dryCoughData[date].evening.length > 0
          ? dryCoughData[date].evening.reduce((a, b) => a + b) /
              dryCoughData[date].evening.length
          : 0
      );
      dryCoughs.night.push(
        dryCoughData[date].night.length > 0
          ? dryCoughData[date].night.reduce((a, b) => a + b) /
              dryCoughData[date].night.length
          : 0
      );
    }

    this.setState({ dryCoughs }, () => {
      console.log("Dry Coughs:", this.state.dryCoughs);
    });
  }
  convertToIST(utcTimestamp) {
    const date = new Date(utcTimestamp);
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istTimestamp = date.getTime() + istOffset;
    return new Date(istTimestamp);
  }

  dryCoughDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.dryCoughStartDate).format("DD/MM/YYYY");
    const endDate = moment(this.state.dryCoughEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ dryCoughDates: formattedDates });

    this.dryCoughPlotData(this.state.records, dates);
  };

  wetCoughPlotData(records, dates) {
    let wetCoughs = {
      morning: [],
      noon: [],
      evening: [],
      night: [],
    };

    let wetCoughData = {};

    dates.forEach((date) => {
      wetCoughData[date] = { morning: [], noon: [], evening: [], night: [] };
    });

    records.forEach((record) => {
      const istTimestamp = this.convertToIST(record.timestamp);
      const date = moment(istTimestamp).format("DD/MM/YYYY");
      const time = moment(istTimestamp).format("HH:mm:ss");

      let period = "";
      if (
        moment(time, "HH:mm:ss").isBetween(
          moment("00:00:00", "HH:mm:ss"),
          moment("12:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "morning";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("12:00:00", "HH:mm:ss"),
          moment("18:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "noon";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("18:00:00", "HH:mm:ss"),
          moment("20:00:00", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "evening";
      } else if (
        moment(time, "HH:mm:ss").isBetween(
          moment("20:00:00", "HH:mm:ss"),
          moment("23:59:59", "HH:mm:ss"),
          null,
          "[)"
        )
      ) {
        period = "night";
      }

      if (dates.includes(date)) {
        wetCoughData[date][period].push(record.wet_sequence_count || 0);
      }
      console.log("date,time,period", date, time, period);
    });

    for (const date in wetCoughData) {
      wetCoughs.morning.push(
        wetCoughData[date].morning.length > 0
          ? wetCoughData[date].morning.reduce((a, b) => a + b) /
              wetCoughData[date].morning.length
          : 0
      );
      wetCoughs.noon.push(
        wetCoughData[date].noon.length > 0
          ? wetCoughData[date].noon.reduce((a, b) => a + b) /
              wetCoughData[date].noon.length
          : 0
      );
      wetCoughs.evening.push(
        wetCoughData[date].evening.length > 0
          ? wetCoughData[date].evening.reduce((a, b) => a + b) /
              wetCoughData[date].evening.length
          : 0
      );
      wetCoughs.night.push(
        wetCoughData[date].night.length > 0
          ? wetCoughData[date].night.reduce((a, b) => a + b) /
              wetCoughData[date].night.length
          : 0
      );
    }

    this.setState({ wetCoughs }, () => {
      console.log("Wet Coughs:", this.state.wetCoughs);
    });
  }

  wetCoughDateFilter = () => {
    let dates = [];
    const startDate = moment(this.state.wetCoughStartDate).format("DD/MM/YYYY");
    const endDate = moment(this.state.wetCoughEndDate).format("DD/MM/YYYY");

    this.state.dates.map((date) => {
      if (
        moment(date, "DD/MM/YYYY").isBetween(
          moment(startDate, "DD/MM/YYYY"),
          moment(endDate, "DD/MM/YYYY"),
          "day",
          "[]"
        )
      ) {
        dates = [...dates, date];
      }
    });

    let formattedDates = [];

    dates.map((date) => {
      formattedDates = [
        ...formattedDates,
        moment(date, "DD/MM/YYYY").format("DD MMM"),
      ];
    });

    this.setState({ wetCoughDates: formattedDates });

    this.wetCoughPlotData(this.state.records, dates);
  };

  report = () => {
    this.setState({ tab: "report" });
    // console.log(this.state.tab)
  };

  medical = () => {
    this.setState({ tab: "medical" });
    // console.log(this.state.tab)
  };

  statusCall = (statusValue) => {
    const userid = decodeURIComponent(this.props.match.params.patientId);

    const status = statusValue;

    console.log(userid, status);

    var formdata = new FormData();
    formdata.append("patientId", userid.toString());
    formdata.append("status", status);

    console.log(formdata);

    // let body = JSON.stringify({ patientId: userid.toString(), status : status})

    // console.log(body)

    axios({
      method: "POST",
      url: `/updatePatientStatus`,
      data: formdata,
      headers: {
        accessToken: localStorage.accessToken,
      },
      // body: JSON.stringify({ patientId: userid.toString(), status : status})
    }).then((response) => {
      console.log(response.data.status);
      if (response.data.status === "SUCCESS") {
        Swal.fire({
          icon: "success",
          title: "Status Updated",
          text: response.data.status,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message,
        });
      }
    });
  };

  updatePatientCall = () => {
    const patientData = {
      userId: localStorage.getItem("doctorId"),
      patientId: decodeURIComponent(this.props.match.params.patientId),
      study_data: this.state.studyAndAdverse,
      occupation: this.state.user.occupation,
      location: this.state.user.location,
      medicationHistory: JSON.stringify(this.state.medicationHistoryData),
      income: this.state.user.income,
      personnel_history: this.state.personalHistory,
      gender: this.state.user.gender,
      weight: this.state.user.weight,
      race: this.state.user.race,
      religion: this.state.user.religion,
      education: this.state.user.education,
      createdOn: this.state.user.createdOn,
      // patient_type: "In Patient",
      height: this.state.user.height,
      firstname: this.state.user.firstname,
      clinicalTest: JSON.stringify(this.state.clinicalTestData),
      surgicalHistory: JSON.stringify(this.state.surgicalHistoryData),
      mobileNumber: this.state.user.mobileNumber,
      age: this.state.user.age,
      medicalHistory: this.state.medicalhistory,
      status: this.state.user.status,
      adminId: this.state.adminId,
    };
    if (this.case2Validations(2)) {
      console.log(patientData);
      var formdata = new FormData();
      formdata.append("patientData", JSON.stringify(patientData));
      formdata.append("doctorId", this.state.doctorId);
      formdata.append("adminId", this.state.adminId);
      console.log(formdata);

      axios({
        method: "POST",
        url: "/updatePatient",
        data: formdata,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Patient Record Updated",
              text: response.data.status,
            });
            this.getPatientData();
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable To Update Patient",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable To Update Patient, validation failed at Medical Records Section",
      });
    }
  };

  updateMedicalRecord = () => {
    const userid = decodeURIComponent(this.props.match.params.patientId);
    const patientData = {
      userId: localStorage.getItem("doctorId"),
      // patientId: this.props.match.params.patientId,
      study_data: this.state.studyAndAdverse,
      // occupation: this.state.user.occupation,
      // location: this.state.user.location,
      medicationHistory: JSON.stringify(this.state.medicationHistoryData),
      // income: this.state.user.income,
      personnel_history: this.state.personalHistory,
      // gender: this.state.user.gender,
      // weight: this.state.user.weight,
      // race: this.state.user.race,
      // religion: this.state.user.religion,
      // education: this.state.user.education,
      createdOn: this.state.created,
      // patient_type: "In Patient",
      // height: this.state.user.height,
      // firstname: this.state.user.firstname,
      clinicalTest: JSON.stringify(this.state.clinicalTestData),
      surgicalHistory: JSON.stringify(this.state.surgicalHistoryData),
      // mobileNumber: this.state.user.mobileNumber,
      // age: this.state.user.age,
      medicalhistory: this.state.medicalhistory,
      status: this.state.user.status,
    };
    if (this.case2Validations(2)) {
      console.log(patientData);
      var formdata = new FormData();
      formdata.append("medicalRecord", JSON.stringify(patientData));
      formdata.append("doctorId", this.state.doctorId);
      formdata.append("patient_id", userid.toString());
      console.log(formdata);

      axios({
        method: "POST",
        url: "/updateMedicalRecord",
        data: formdata,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Patient Record Updated",
              text: response.data.status,
            });
            this.getPatientData();
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable To Update Patient",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable To Update Patient, validation failed at Medical Records Section",
      });
    }
  };

  addMedicalRecord = () => {
    const patientData = {
      userId: localStorage.getItem("doctorId"),
      patientId: decodeURIComponent(this.props.match.params.patientId),
      study_data: this.state.studyAndAdverse,
      // occupation: this.state.user.occupation,
      // location: this.state.user.location,
      medicationHistory: JSON.stringify(this.state.medicationHistoryData),
      // income: this.state.user.income,
      personnel_history: this.state.personalHistory,
      // gender: this.state.user.gender,
      // weight: this.state.user.weight,
      // race: this.state.user.race,
      // religion: this.state.user.religion,
      // education: this.state.user.education,
      // createdOn: this.state.user.createdOn,
      patient_type: "In Patient",
      // height: this.state.user.height,
      firstname: this.state.user.firstname,
      clinicalTest: JSON.stringify(this.state.clinicalTestData),
      surgicalHistory: JSON.stringify(this.state.surgicalHistoryData),
      // mobileNumber: this.state.user.mobileNumber,
      // age: this.state.user.age,
      medicalhistory: this.state.medicalhistory,
      status: this.state.user.status,
    };
    if (this.case2Validations(2)) {
      console.log(patientData);
      const userid = decodeURIComponent(this.props.match.params.patientId);
      var formdata = new FormData();
      formdata.append("medicalRecords", JSON.stringify(patientData));
      formdata.append("doctorId", this.state.doctorId);
      // formdata.append("recordId", this.state.latestRecord.recordId);
      formdata.append("patientId", userid.toString());
      console.log(formdata);

      axios({
        method: "POST",
        url: "/addMedicalRecord",
        data: formdata,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          console.log(response.status);
          if (response.status === 200) {
            Swal.fire({
              icon: "success",
              title: "Patient Record Added",
              text: response.data.status,
            });
            this.getPatientData();
          }
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable To Add Patient",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Unable To Update Patient, validation failed at Medical Records Section",
      });
    }
  };

  case2Validations = (e) => {
    let alcoholValidation = false;
    let tobaccoValidation = false;
    let narcoticValidation = false;
    let personnelHistoryValidation = false;
    let substanceAbuseValidation = false;
    if (
      this.state.personalHistory.alcohol ||
      this.state.personalHistory.tobacco ||
      this.state.personalHistory.drugs ||
      this.state.personalHistory.substanceAbuse === "No"
    ) {
      substanceAbuseValidation = true;
    } else {
      this.setState({ historyOfSubstanceAbuseError: true });
      substanceAbuseValidation = false;
    }
    if (
      this.state.personalHistory.alcoholAbuse === "No" ||
      this.state.personalHistory.alcoholUsageDuration !== ""
    ) {
      alcoholValidation = true;
    } else {
      this.setState({
        alcoholUsageDurationError: true,
      });
      alcoholValidation = false;
    }
    if (
      this.state.personalHistory.tobaccoAbuse === "No" ||
      this.state.personalHistory.tobaccoUsageDuration !== ""
    ) {
      tobaccoValidation = true;
    } else {
      this.setState({
        tobaccoUsageDurationError: true,
      });
      tobaccoValidation = false;
    }
    if (
      this.state.personalHistory.narcoticsAbuse === "No" ||
      this.state.personalHistory.narcoticsUsageDuration !== ""
    ) {
      narcoticValidation = true;
    } else {
      this.setState({
        narcoticsUsageDurationError: true,
      });
      narcoticValidation = false;
    }
    if (
      this.state.personalHistory.personnelHistory === "No" ||
      this.state.personalHistory.personnelHistoryComments !== ""
    ) {
      personnelHistoryValidation = true;
    } else {
      this.setState({
        personnelHistoryCommentsError: true,
      });
      personnelHistoryValidation = false;
    }
    if (
      alcoholValidation &&
      tobaccoValidation &&
      narcoticValidation &&
      personnelHistoryValidation &&
      substanceAbuseValidation
    ) {
      this.setState({ positionVal: e });
      return true;
    }
    return false;
  };

  postionChange = (e) => {
    console.log("logged", e);
    switch (e) {
      case 1:
        this.setState({ positionVal: e });
        break;
      case 2:
        this.case2Validations(e);
        break;
      case 3:
        this.setState({ positionVal: e });
        break;
      case 4:
        this.setState({ positionVal: e });
        break;
      case 5:
        this.setState({ positionVal: e });
        break;
      case 6:
        this.setState({ positionVal: e });
        break;
      case 7:
        this.setState({ positionVal: e });
        break;
    }
    console.log(this.state.positionVal);
  };

  toFeet = (n) => {
    if (isNaN(n)) {
      return "NA";
    } else {
      var realFeet = (n * 0.3937) / 12;
      var feet = Math.floor(realFeet);
      var inches = Math.round((realFeet - feet) * 12);
      return feet + "'" + inches + '"';
    }
  };

  indexOptions = () => {
    var arr = [];
    for (let i = 0; i < this.state.mdlength; i++) {
      arr.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return arr;
  };

  indexChangeHandler = (e) => {
    console.log(this.state.index);
    this.setState({ index: e.target.value });
    console.log(this.state.index);
  };
  showPdf = (reportId) => {
    if (reportId) {
      console.log("showing pdf");
      const { patientId } = this.props.match.params;
      const doctorId = this.state.doctorId;
      axios({
        method: "GET",
        url: `/clinicalreport/?reportID=${reportId}&patientID=${patientId}&doctorId=${doctorId}`,
        headers: {
          accessToken: localStorage.accessToken,
        },
      })
        .then((response) => {
          window.open(response.data.reportURL);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Unable To get PDF",
          });
        });
    }
  };

  render() {
    const activeTab = {
      backgroundColor: "#fff",
      borderColor: "#fff",
      color: "#46360999",
      fontWeight: "bold",
    };
    const activateLink = {
      textDecoration: "underline #0B0080",
      cursor: "pointer",
      color: "#0B0080",
    };

    const riskScore = this.state.riskScore;
    let lhiImage;
    let lhiText;
    if (riskScore >= 1 && riskScore <= 3) {
      lhiImage = (
        <img className="_image_risk" src={low_risk_img} alt="Low Risk" />
      );
      lhiText = <p className="_text_risk">Low</p>;
    } else if (riskScore >= 4 && riskScore <= 6) {
      lhiImage = (
        <img className="_image_risk" src={med_risk_img} alt="medium Risk" />
      );
      lhiText = <p className="_text_risk">Medium</p>;
    } else if (riskScore >= 7 && riskScore <= 10) {
      lhiImage = (
        <img className="_image_risk" src={high_risk_img} alt="high Risk" />
      );
      lhiText = <p className="_text_risk">High</p>;
    }

    const covidriskScore = this.state.covidRiskScore;
    let covidImgRisk;
    let covidTextRisk;
    if (covidriskScore >= 1 && covidriskScore <= 3) {
      covidImgRisk = (
        <img className="_image_risk" src={low_risk_img} alt="Low Risk" />
      );
      covidTextRisk = <p className="_text_risk">Low </p>;
    } else if (covidriskScore >= 4 && covidriskScore <= 6) {
      covidImgRisk = (
        <img className="_image_risk" src={med_risk_img} alt="medium Risk" />
      );
      covidTextRisk = <p className="_text_risk">Medium</p>;
    } else if (covidriskScore >= 7 && covidriskScore <= 10) {
      covidImgRisk = (
        <img className="_image_risk" src={high_risk_img} alt="high Risk" />
      );
      covidTextRisk = <p className="_text_risk">High </p>;
    }

    const tbRiskScore = this.state.tbRiskScore;
    let tbImgRisk;
    let tbTextRisk;
    if (tbRiskScore >= 1 && tbRiskScore <= 3) {
      tbImgRisk = (
        <img className="_image_risk" src={low_risk_img} alt="Low Risk" />
      );
      tbTextRisk = <p className="_text_risk">Low </p>;
    } else if (tbRiskScore >= 4 && tbRiskScore <= 6) {
      tbImgRisk = (
        <img className="_image_risk" src={med_risk_img} alt="medium Risk" />
      );
      tbTextRisk = <p className="_text_risk">Medium </p>;
    } else if (tbRiskScore >= 7 && tbRiskScore <= 10) {
      tbImgRisk = (
        <img className="_image_risk" src={high_risk_img} alt="high Risk" />
      );
      tbTextRisk = <p className="_text_risk">High </p>;
    }

    const asthmaRiskScore = this.state.asthmaRiskScore;
    let asthmaImgRisk;
    let asthmaTextRisk;
    if (asthmaRiskScore >= 1 && asthmaRiskScore <= 3) {
      asthmaImgRisk = (
        <img className="_image_risk" src={low_risk_img} alt="Low Risk" />
      );
      asthmaTextRisk = <p className="_text_risk">Low </p>;
    } else if (asthmaRiskScore >= 4 && asthmaRiskScore <= 6) {
      asthmaImgRisk = (
        <img className="_image_risk" src={med_risk_img} alt="medium Risk" />
      );
      asthmaTextRisk = <p className="_text_risk">Medium </p>;
    } else if (asthmaRiskScore >= 7 && asthmaRiskScore <= 10) {
      asthmaImgRisk = (
        <img className="_image_risk" src={high_risk_img} alt="high Risk" />
      );
      asthmaTextRisk = <p className="_text_risk">High </p>;
    }

    const copdRiskScore = this.state.copdRiskScore;
    let copdImgRisk;
    let copdTextRisk;
    if (copdRiskScore >= 1 && copdRiskScore <= 3) {
      copdImgRisk = (
        <img className="_image_risk" src={low_risk_img} alt="Low Risk" />
      );
      copdTextRisk = <p className="_text_risk">Low </p>;
    } else if (copdRiskScore >= 4 && copdRiskScore <= 6) {
      copdImgRisk = (
        <img className="_image_risk" src={med_risk_img} alt="medium Risk" />
      );
      copdTextRisk = <p className="_text_risk">Medium </p>;
    } else if (copdRiskScore >= 7 && copdRiskScore <= 10) {
      copdImgRisk = (
        <img className="_image_risk" src={high_risk_img} alt="high Risk" />
      );
      copdTextRisk = <p className="_text_risk">High </p>;
    }

    let processedData = [];

    const createdIST = moment
      .utc(this.state.created)
      .local()
      .format("YYYY-MM-DD HH:mm:ss");

    // Iterate through the original risk score data
    this.state.riskScoreData.forEach((score) => {
      let label = ""; // Initialize the label for the current data point

      // Determine the label based on the score range
      if (score <= 3) {
        label = "Low";
      } else if (score <= 6) {
        label = "Medium";
      } else {
        label = "High";
      }

      // Add the processed data point to the array
      processedData.push({
        x: processedData.length + 1, // Assuming the x-axis is categorical
        y: score, // Original risk score
        label: label, // Label based on the score range
      });
    });

    return (
      <>
        {this.state.loading ? (
          <div className="patient-details-medical-conditions">
            <PatientDetailsNew
              id={this.state.patientIdSQL}
              dryCoughData={this.state.dryCoughs}
              wetCoughData={this.state.wetCoughs}
              dryCoughDates={this.state.dryCoughDates}
              wetCoughDates={this.state.wetCoughDates}
              riskScoreDates={this.state.riskScoreDates}
              // riskScoreData = {this.state.riskScorePlotData}
              status={this.state.status}
              statusCall={this.statusCall}
              patientName={this.state.userId}
              responseData = {this.state.responseData}
            />
            {localStorage.validation === "true" ||
            localStorage.longitudinal_study === "true" ? (
              <div className={(localStorage.validation==='true' && localStorage.longitudinal_study!=='true')?'medicalParent-validation':"medicalParent"}>
                <div className="medicalRecords-status-container">
                  <h4
                    className={
                      localStorage.validation !== "true"
                        ? "medicalRecords-heading"
                        : "medicalRecords-heading-validation"
                    }
                  >
                    Medical Records
                  </h4>
                  {/* {localStorage.validation !== "true" ||
                localStorage.longitudinal_study === "true" ? (
                  ""
                ) : (
                  <div className="patients__value-filter__item">
                    <p className="medicalRecords-status">Status</p>
                    <select
                      value={this.state.status}
                      onChange={(e) => this.statusCall(e.target.value)}
                    >
                      <option value="NEW">NEW</option>
                      <option value="COMPLETED">COMPLETED</option>
                    </select>
                  </div>
                )} */}
                </div>
                {/* {localStorage.longitudinal_study === "true" &&
                  this.state.add === false && (
                    
                  )} */}
                {localStorage.longitudinal_study === "true" &&
                  this.state.add === false && (
                    <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'center'}}>
                    <div className="indexFilterStyle patients__value-filter__item">
                      <select onChange={this.indexChangeHandler.bind(this)}>
                        {this.indexOptions()}
                      </select>
                    </div>
                    <div>
                    <div className="buttonStyles">
                      <button
                        className="btn primary-button"
                        onClick={() => {
                          this.setState({
                            add: true,

                            surgicalHistoryData: [],
                            showSurgicalModal: false,
                            medicationHistoryData: [],
                            showMedicationHistoryModal: false,
                            clinicalTestData: [],
                            showClinicalTestModal: false,
                            personalHistory: {
                              alcoholAbuse: "No",
                              personnelHistory: "No",
                              tobaccoUsageDuration: "",
                              substanceAbuse: "No",
                              tobacco: false,
                              drugs: false,
                              alcohol: false,
                              alcoholUsageDuration: "",
                              narcoticsAbuse: "No",
                              personnelHistoryComments: "",
                              tobaccoAbuse: "No",
                              narcoticsUsageDuration: "",
                              active_tb_past: "No",
                              known_person_having_active_tb: "No",
                            },
                            medicalhistory: {
                              heart_disease: false,
                              high_blood_pressure: false,
                              kidney_problem: false,
                              diabetes: false,
                              lung_disease: false,
                              weak_immune_system: false,
                              stroke: false,
                              major_operations: false,
                              comments: "",
                            },
                            studyAndAdverse: {
                              adverse_event: "No",
                              adverse_event_details: "",
                              study_complete: "No",
                              study_complete_date: null,
                              subject_discontinuity_reason: "",
                              subject_death_date: null,
                              cause_of_death: "",
                            },
                            historyOfSubstanceAbuseError: false,
                            alcoholUsageDurationError: false,
                            tobaccoUsageDurationError: false,
                            narcoticsUsageDurationError: false,
                          });
                          this.postionChange(1);
                        }}
                      >
                        {" "}
                        Add New Record{" "}
                      </button>
                    </div>
                    <div className="buttonStyles">
                      <p style={{fontSize:'14px', height:'10px',}}>Record Created On: {createdIST}</p>
                    </div>
                    </div>   
                    </div>  
                    
                  )}
                {/* {localStorage.longitudinal_study === "true" &&
                  this.state.add === false && (
                    
                  )} */}
                {localStorage.longitudinal_study === "true" &&
                  this.state.add === true && (
                    <div className="buttonStyles">
                      <button
                        className="btn primary-button"
                        onClick={() => {
                          this.setState({
                            add: false,
                            index: 0,
                          });
                          this.postionChange(1);
                        }}
                      >
                        {" "}
                        Cancel{" "}
                      </button>
                    </div>
                  )}
                <div className="progressBar">
                  {medicalConditions.map((condition) => {
                    return (
                      <div
                        key={condition.id}
                        onClick={() => this.postionChange(condition.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <div className="d-flex">
                          <div className="d-grid justify-items-center">
                            <img
                              alt=""
                              src={
                                this.state.positionVal === condition.id
                                  ? yellowTick
                                  : this.state.positionVal > condition.id
                                  ? greenTick
                                  : greyTick
                              }
                            />
                            <div
                              className={`title ${
                                this.state.positionVal === condition.id
                                  ? "yellowTitle"
                                  : this.state.positionVal > condition.id
                                  ? "greenTitle"
                                  : "greyTitle"
                              }`}
                            >
                              {condition.name}
                            </div>
                          </div>
                          {medicalConditions.length !== condition.id ? (
                            <img
                              className={
                                localStorage.validation !== "true"
                                  ? "lineDecoration"
                                  : "lineDecoration-validation"
                              }
                              alt=""
                              src={
                                this.state.positionVal === condition.id
                                  ? yellowLine
                                  : this.state.positionVal > condition.id
                                  ? greenLine
                                  : greyLine
                              }
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
                {(() => {
                  if (this.state.positionVal === 1) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          Medical Records
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            <span className="number">1. </span>Does the subject
                            have any History of Substance abuse?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="substanceAbuse"
                                value={
                                  this.state.personalHistory.substanceAbuse
                                }
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.substanceAbuse =
                                    e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.personalHistory.substanceAbuse ===
                              "Yes" && (
                              <div className="subquestions">
                                Please specify the Substance:
                                <div className="checkboxes">
                                  <FormControlLabel
                                    control={
                                      <GreenCheckbox
                                        checked={
                                          this.state.personalHistory.alcohol
                                        }
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            this.setState({
                                              historyOfSubstanceAbuseError: false,
                                            });
                                          }
                                          const personalHistory =
                                            this.state.personalHistory;
                                          personalHistory.alcohol =
                                            e.target.checked;
                                          this.setState({
                                            personalHistory,
                                          });
                                        }}
                                      />
                                    }
                                    label="Alcohol"
                                  />
                                  <FormControlLabel
                                    control={
                                      <GreenCheckbox
                                        checked={
                                          this.state.personalHistory.tobacco
                                        }
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            this.setState({
                                              historyOfSubstanceAbuseError: false,
                                            });
                                          }
                                          const personalHistory =
                                            this.state.personalHistory;
                                          personalHistory.tobacco =
                                            e.target.checked;
                                          this.setState({
                                            personalHistory,
                                          });
                                        }}
                                      />
                                    }
                                    label="Tobacco"
                                  />
                                  <FormControlLabel
                                    control={
                                      <GreenCheckbox
                                        checked={
                                          this.state.personalHistory.drugs
                                        }
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            this.setState({
                                              historyOfSubstanceAbuseError: false,
                                            });
                                          }
                                          const personalHistory =
                                            this.state.personalHistory;
                                          personalHistory.drugs =
                                            e.target.checked;
                                          this.setState({
                                            personalHistory,
                                          });
                                        }}
                                      />
                                    }
                                    label="Drugs (Narcotic)"
                                  />
                                </div>
                                {this.state.historyOfSubstanceAbuseError && (
                                  <div className="errorMessage">
                                    Please Select Atleast One Substance Abuse
                                  </div>
                                )}
                              </div>
                            )}
                          </div>

                          <div className="questions">
                            <span className="number">2. </span>Did the Subject
                            continuing the use of Alcohol?``
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="alcohol"
                                value={this.state.personalHistory.alcoholAbuse}
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.alcoholAbuse = e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.personalHistory.alcoholAbuse !==
                              "No" && (
                              <Fragment>
                                <div className="subquestions">
                                  Duration of Alcohol use:
                                </div>

                                <div>
                                  <input
                                    className="border"
                                    type="text"
                                    value={
                                      this.state.personalHistory
                                        .alcoholUsageDuration
                                    }
                                    onChange={(e) => {
                                      console.log(e.target.value);
                                      if (e.target.value === "") {
                                        this.setState({
                                          alcoholUsageDurationError: true,
                                        });
                                      }
                                      const personalHistory =
                                        this.state.personalHistory;
                                      personalHistory.alcoholUsageDuration =
                                        e.target.value;
                                      this.setState({
                                        personalHistory,
                                        alcoholUsageDurationError: false,
                                      });
                                    }}
                                  />
                                </div>
                                {this.state.alcoholUsageDurationError && (
                                  <div className="errorMessage">
                                    Duration Required*
                                  </div>
                                )}
                              </Fragment>
                            )}
                          </div>
                          <div className="questions">
                            <span className="number">3. </span>Did the Subject
                            continuing the use of Tobacco?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="tobacco"
                                value={this.state.personalHistory.tobaccoAbuse}
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.tobaccoAbuse = e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.personalHistory.tobaccoAbuse ===
                              "Yes" && (
                              <Fragment>
                                <div className="subquestions">
                                  Duration of Tobacco use:
                                </div>
                                <div>
                                  <input
                                    className="border"
                                    type="text"
                                    value={
                                      this.state.personalHistory
                                        .tobaccoUsageDuration
                                    }
                                    onChange={(e) => {
                                      if (e.target.value === "") {
                                        this.setState({
                                          tobaccoUsageDurationError: true,
                                        });
                                      }
                                      const personalHistory =
                                        this.state.personalHistory;
                                      personalHistory.tobaccoUsageDuration =
                                        e.target.value;
                                      this.setState({
                                        personalHistory,
                                        tobaccoUsageDurationError: false,
                                      });
                                    }}
                                  />
                                </div>
                                {this.state.tobaccoUsageDurationError && (
                                  <div className="errorMessage">
                                    Duration Required*
                                  </div>
                                )}
                              </Fragment>
                            )}
                          </div>
                          <div className="questions">
                            <span className="number">4. </span>Did the Subject
                            continuing the use of Drugs (Narcotic)?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="drugs"
                                value={
                                  this.state.personalHistory.narcoticsAbuse
                                }
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.narcoticsAbuse =
                                    e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.personalHistory.narcoticsAbuse ===
                              "Yes" && (
                              <Fragment>
                                <div className="subquestions">
                                  Duration of Drugs (Narcotic) use:
                                </div>
                                <div>
                                  <input
                                    className="border"
                                    type="text"
                                    value={
                                      this.state.personalHistory
                                        .narcoticsUsageDuration
                                    }
                                    onChange={(e) => {
                                      if (e.target.value === "") {
                                        this.setState({
                                          narcoticsUsageDurationError: true,
                                        });
                                      }
                                      const personalHistory =
                                        this.state.personalHistory;
                                      personalHistory.narcoticsUsageDuration =
                                        e.target.value;
                                      this.setState({
                                        personalHistory,
                                        narcoticsUsageDurationError: false,
                                      });
                                    }}
                                  />
                                </div>
                                {this.state.narcoticsUsageDurationError && (
                                  <div className="errorMessage">
                                    Duration Required*
                                  </div>
                                )}
                              </Fragment>
                            )}
                          </div>
                          <div className="questions">
                            <span className="number">5. </span>Did the subject
                            having any other personal history?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="personalHistory"
                                value={
                                  this.state.personalHistory.personnelHistory
                                }
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.personnelHistory =
                                    e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                            {this.state.personalHistory.personnelHistory ===
                              "Yes" && (
                              <Fragment>
                                <div className="subquestions">
                                  Please Specify Your Comment:
                                </div>
                                <div>
                                  <input
                                    className="border"
                                    type="text"
                                    value={
                                      this.state.personalHistory
                                        .personnelHistoryComments
                                    }
                                    onChange={(e) => {
                                      if (e.target.value === "") {
                                        this.setState({
                                          personnelHistoryCommentsError: true,
                                        });
                                      }
                                      const personalHistory =
                                        this.state.personalHistory;
                                      personalHistory.personnelHistoryComments =
                                        e.target.value;
                                      this.setState({
                                        personalHistory,
                                        personnelHistoryCommentsError: false,
                                      });
                                    }}
                                  />
                                </div>
                                {this.state.personnelHistoryCommentsError && (
                                  <div className="errorMessage">
                                    Comment Required*
                                  </div>
                                )}
                              </Fragment>
                            )}
                          </div>
                          <div className="questions">
                            <span className="number">6. </span>Did the subject
                            has active TB in the past?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="active_tb_past"
                                name="active_tb_past"
                                value={
                                  this.state.personalHistory.active_tb_past
                                }
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.active_tb_past =
                                    e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                          <div className="questions">
                            <span className="number">7. </span>Did the subject
                            family member, co-worker or friend has active TB?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="known_person_having_active_tb"
                                name="known_person_having_active_tb"
                                value={
                                  this.state.personalHistory
                                    .known_person_having_active_tb
                                }
                                onChange={(e) => {
                                  const personalHistory =
                                    this.state.personalHistory;
                                  personalHistory.known_person_having_active_tb =
                                    e.target.value;
                                  this.setState({ personalHistory });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                                <FormControlLabel
                                  value="Unknown"
                                  control={<Radio />}
                                  label="Unknown"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                        </div>

                        <div className="buttonStyles">
                          {/* <button className="btn secondary-button"> Cancel </button> */}
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(2)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else if (this.state.positionVal === 2) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          {medicalConditions[this.state.positionVal - 1]?.name}
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            Please fill out the following table, if applicable:
                          </div>
                        </div>
                        <div className="surgicalHistory">
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Event/Diagnosis</TableCell>
                                  <TableCell>Start Date(DD/MM/YYYY)</TableCell>
                                  <TableCell>End Date(DD/MM/YYYY)</TableCell>
                                  <TableCell>On Going(Yes/No)</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.surgicalHistoryData.map(
                                  (row, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{row.Diagnosis}</TableCell>
                                      <TableCell>{row.startDate}</TableCell>
                                      <TableCell>{row.endDate}</TableCell>
                                      <TableCell>
                                        {row.ongoing === "Yes" ||
                                        row.ongoing === true
                                          ? "True"
                                          : "False"}
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => {
                              this.setState({ showSurgicalModal: true });
                            }}
                          >
                            Add Row
                          </button>
                        </div>
                        {this.state.showSurgicalModal ? (
                          <SurgicalHistoryDialog
                            open={this.state.showSurgicalModal}
                            handleClose={(data) =>
                              this.onCloseSurgicalModal(data)
                            }
                          />
                        ) : (
                          ""
                        )}
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(1)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(3)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else if (this.state.positionVal === 3) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          Medical Conditions
                        </div>
                        <div className={(localStorage.validation==='true' && localStorage.longitudinal_study!=='true')?'medicalrecord-validation':"medicalrecord"}>
                          <div className="questions">
                            <span className="number">1. </span>Do you have any
                            of the following medical conditions(check all that
                            apply) ?
                            <div className="checkboxes">
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory.lung_disease
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.lung_disease =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Lung Disease
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory.heart_disease
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.heart_disease =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Heart Disease
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={this.state.medicalhistory.diabetes}
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.diabetes =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Diabetes
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory
                                        .high_blood_pressure
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.high_blood_pressure =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    High Blood Pressure
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory.kidney_problem
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.kidney_problem =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Kidney Problem
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory.major_operations
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.major_operations =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Major Operations like Organ Transplant
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={
                                      this.state.medicalhistory
                                        .weak_immune_system
                                    }
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.weak_immune_system =
                                        e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Week Immune System
                                  </Typography>
                                }
                              />
                              <FormControlLabel
                                control={
                                  <GreenCheckbox
                                    checked={this.state.medicalhistory.stroke}
                                    onChange={(e) => {
                                      const medicalhistory =
                                        this.state.medicalhistory;
                                      medicalhistory.stroke = e.target.checked;
                                      this.setState({ medicalhistory });
                                    }}
                                  />
                                }
                                label={
                                  <Typography style={{ fontFamily: "Roboto"}}>
                                    Stroke
                                  </Typography>
                                }
                              />
                            </div>
                          </div>
                          <div className="comments-container">
                            <input
                              className="comments"
                              placeholder="Comments"
                              value={this.state.medicalhistory.comments}
                              onChange={(e) => {
                                const medicalhistory =
                                  this.state.medicalhistory;
                                medicalhistory.comments = e.target.value;
                                this.setState({ medicalhistory });
                              }}
                            />
                          </div>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(2)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(4)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else if (this.state.positionVal === 4) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          {medicalConditions[this.state.positionVal - 1]?.name}
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            Please fill out the following table, if applicable:
                          </div>
                        </div>
                        <div className="medicationHistory">
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Name of the Drug</TableCell>
                                  <TableCell>Dose</TableCell>
                                  <TableCell>Start Date(DD/MM/YYYY)</TableCell>
                                  <TableCell>End Date(DD/MM/YYYY)</TableCell>
                                  <TableCell>Drug Response</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.medicationHistoryData.map(
                                  (row, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{row.drugName}</TableCell>
                                      <TableCell>{row.dose}</TableCell>
                                      <TableCell>{row.startDate}</TableCell>
                                      <TableCell>{row.endDate}</TableCell>
                                      <TableCell>{row.response}</TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => {
                              this.setState({
                                showMedicationHistoryModal: true,
                              });
                            }}
                          >
                            Add Row
                          </button>
                        </div>
                        {this.state.showMedicationHistoryModal ? (
                          <MedicationHistoryDialog
                            open={this.state.showMedicationHistoryModal}
                            handleClose={(data) =>
                              this.onCloseMedicationModal(data)
                            }
                          />
                        ) : (
                          ""
                        )}
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(3)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(5)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else if (this.state.positionVal === 5) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          {medicalConditions[this.state.positionVal - 1]?.name}
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            Please fill out the following table, if applicable:
                          </div>
                        </div>
                        <div className="surgicalHistory">
                          <TableContainer component={Paper}>
                            <Table aria-label="simple table">
                              <TableHead>
                                <TableRow>
                                  <TableCell>Test ID</TableCell>
                                  <TableCell>Test Name</TableCell>
                                  <TableCell>Count</TableCell>
                                  <TableCell>Parameter</TableCell>
                                  <TableCell>Value</TableCell>
                                  <TableCell>Comments</TableCell>
                                  <TableCell>Report</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {this.state.clinicalTestData.map(
                                  (row, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{row.test_id}</TableCell>
                                      <TableCell>{row.test_name}</TableCell>
                                      <TableCell>{row.test_count}</TableCell>
                                      <TableCell>
                                        {row.parameters.map(
                                          (param, paramIndex) => (
                                            <div key={paramIndex}>
                                              {param.test_parameter_name}
                                            </div>
                                          )
                                        )}
                                      </TableCell>
                                      <TableCell>
                                        {row.parameters.map(
                                          (param, paramIndex) => (
                                            <div key={paramIndex}>
                                              {param.test_parameter_value}
                                            </div>
                                          )
                                        )}
                                      </TableCell>
                                      <TableCell>{row.comments}</TableCell>
                                      <TableCell>
                                        <div
                                          onClick={() =>
                                            this.showPdf(row.reportID)
                                          }
                                          style={
                                            row?.reportID !==
                                            (undefined && null)
                                              ? activateLink
                                              : {}
                                          }
                                        >
                                          Views
                                        </div>
                                      </TableCell>
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => {
                              this.setState({
                                showClinicalTestModal: true,
                              });
                            }}
                          >
                            Add Row
                          </button>
                        </div>
                        {this.state.showClinicalTestModal ? (
                          <ClinicalTestDialog
                            open={this.state.showClinicalTestModal}
                            handleClose={(data) =>
                              this.onCloseClinicalModal(data)
                            }
                            userId={decodeURIComponent(this.props.match.params.patientId)}
                            doctorId={this.state.doctorId}
                          />
                        ) : (
                          ""
                        )}
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(4)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(6)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else if (this.state.positionVal === 6) {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          Medical Records
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            <span className="number">1. </span>Did the subject
                            have any adverse event (AE) or serious adverse event
                            (SAE)?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="adverseEvent"
                                value={this.state.studyAndAdverse.adverse_event}
                                onChange={(e) => {
                                  const studyAndAdverse =
                                    this.state.studyAndAdverse;
                                  studyAndAdverse.adverse_event =
                                    e.target.value;
                                  this.setState({ studyAndAdverse });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                          <div className="comments-container">
                            <input
                              className="comments"
                              placeholder="Comments"
                              value={
                                this.state.studyAndAdverse.adverse_event_details
                              }
                              onChange={(e) => {
                                const studyAndAdverse =
                                  this.state.studyAndAdverse;
                                studyAndAdverse.adverse_event_details =
                                  e.target.value;
                                this.setState({ studyAndAdverse });
                              }}
                            />
                          </div>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(5)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          <button
                            className="btn primary-button"
                            onClick={() => this.postionChange(7)}
                          >
                            {" "}
                            Next{" "}
                          </button>
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div>
                        <div className="medicalRecordHeader">
                          {medicalConditions[this.state.positionVal - 1]?.name}
                        </div>
                        <div className="medicalrecord">
                          <div className="questions">
                            <span className="number">1. </span>Did the Patient
                            complete the study?
                            <div className="options">
                              <RadioGroup
                                row
                                aria-label="gender"
                                name="studyCompletion"
                                value={
                                  this.state.studyAndAdverse.study_complete
                                }
                                onChange={(e) => {
                                  const studyAndAdverse =
                                    this.state.studyAndAdverse;
                                  studyAndAdverse.study_complete =
                                    e.target.value;
                                  this.setState({ studyAndAdverse });
                                }}
                              >
                                <FormControlLabel
                                  value="Yes"
                                  control={<Radio />}
                                  label="Yes"
                                />
                                <FormControlLabel
                                  value="No"
                                  control={<Radio />}
                                  label="No"
                                />
                              </RadioGroup>
                            </div>
                          </div>
                          <div className="subquestions">
                            If{" "}
                            <b>‘{this.state.studyAndAdverse.study_complete}’</b>
                            , Please provide the date of patient completion of
                            the study:
                            <div className="options">
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                placeholderText="DD/MM/YYYY"
                                selected={
                                  this.state.studyAndAdverse.study_complete_date
                                }
                                onChange={(date) => {
                                  const studyAndAdverse =
                                    this.state.studyAndAdverse;
                                  studyAndAdverse.study_complete_date = date;
                                  this.setState({ studyAndAdverse });
                                }}
                              />
                            </div>
                          </div>
                          <div className="questions">
                            <span className="number">2. </span>Reason for the
                            subjects discontinuation from the study:
                          </div>
                          <div className="comments-container">
                            <input
                              className="comments"
                              placeholder="Comments"
                              value={
                                this.state.studyAndAdverse
                                  .subject_discontinuity_reason
                              }
                              onChange={(e) => {
                                const studyAndAdverse =
                                  this.state.studyAndAdverse;
                                studyAndAdverse.subject_discontinuity_reason =
                                  e.target.value;
                                this.setState({ studyAndAdverse });
                              }}
                            />
                          </div>
                          <div className="questions">
                            <span className="number">3. </span>In case of
                            subject’s Death:
                          </div>
                          <div className="subquestions">
                            Provide the Date of Death:
                            <div className="options">
                              <DatePicker
                                dateFormat="dd/MM/yyyy"
                                placeholderText="DD/MM/YYYY"
                                selected={
                                  this.state.studyAndAdverse.subject_death_date
                                }
                                onChange={(date) => {
                                  const studyAndAdverse =
                                    this.state.studyAndAdverse;
                                  studyAndAdverse.subject_death_date = date;
                                  this.setState({ studyAndAdverse });
                                }}
                              />
                            </div>
                          </div>
                          <div className="subquestions">Cause of Death:</div>
                          <div className="comments-container">
                            <input
                              className="comments"
                              placeholder="Comments"
                              value={this.state.studyAndAdverse.cause_of_death}
                              onChange={(e) => {
                                const studyAndAdverse =
                                  this.state.studyAndAdverse;
                                studyAndAdverse.cause_of_death = e.target.value;
                                this.setState({ studyAndAdverse });
                              }}
                            />
                          </div>
                        </div>
                        <div className="buttonStyles">
                          <button
                            className="btn secondary-button"
                            onClick={() => this.postionChange(6)}
                          >
                            {" "}
                            Previous{" "}
                          </button>
                          {localStorage.longitudinal_study !== "true" && (
                            <button
                              className="btn primary-button"
                              onClick={() => {
                                this.updatePatientCall();
                                this.postionChange(1);
                              }}
                            >
                              {" "}
                              Save{" "}
                            </button>
                          )}
                          {localStorage.longitudinal_study === "true" &&
                            this.state.add === false && (
                              <button
                                className="btn primary-button"
                                onClick={() => {
                                  this.updateMedicalRecord();
                                  this.postionChange(1);
                                }}
                              >
                                {" "}
                                Update Record{" "}
                              </button>
                            )}
                          {localStorage.longitudinal_study === "true" &&
                            this.state.add === true && (
                              <button
                                className="btn primary-button"
                                onClick={() => {
                                  this.addMedicalRecord();
                                  this.setState({
                                    add: false,
                                  });
                                  this.postionChange(1);
                                }}
                              >
                                {" "}
                                Add{" "}
                              </button>
                            )}
                        </div>
                      </div>
                    );
                  }
                })()}
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              gap: "7px",
              justifyContent: "space-between",
              margin:'15px'
            }}
          >
             <ShimmerThumbnail height={800} width={290} className="m-0" rounded />
              <ShimmerThumbnail
                height={800}
                width={950}
                className="m-0"
                rounded
              />
            </div>
        )}
      </>
    );
  }
}

export default PatientDetail;
